










































































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class AppBar extends Vue {
  /* ------------------------------------
  => Local State Declaration
  ------------------------------------ */
  menu: boolean = false;
  drawer: boolean = false;
  title: string = 'Dev Survey';

  /* ------------------------------------
  => Setter and Getter
  ** (Adopt store variables to local state)
  ------------------------------------ */
  get languageSetting(): boolean {
    return this.$store.state.i18n.languageSetting.header;
  }

  get isLogin(): boolean {
    return this.$store.state.auth.isLogin;
  }

  get profilePictureUrl(): string {
    return this.$store.state.user.currentUser.imgUrl;
  }

  get roleUser(): string {
    return this.$store.state.user.currentUser.role;
  }

  /* ------------------------------------
  => Methods
  ------------------------------------ */
  switchTheme(): void {
    this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
  }

  switchLanguage(param: string): void {
    this.$store.dispatch('i18n/changeLanguage', param);
  }

  logout(): void {
    this.$store.dispatch('auth/logout').then(() => {
      this.$router.push('/login');
    });
  }
}
